import { Location } from '@app/shared/routes';

const TermConditionLocation = new Location({ path: '/legal/term-condition' });

export { TermConditionLocation };
